import { Typography } from "@mui/material";
import { Sidebar } from "../../components/Sidebar";

export const Content = () => {
  return (
    <Sidebar>
      <Typography>Content Page Works 😊</Typography>
    </Sidebar>
  );
};
